import {
    Box,
    Center,
    useColorModeValue,
    Heading,
    Stack,
    Image,
    Link

  } from '@chakra-ui/react';
import { Link as Reactlink } from 'react-router-dom';


  export default function DashboardCard(props) {
    return (
      <Center py={12}>
        
        <Box
          role={'group'}
          p={6}
          maxW={'330px'}
          w={'full'}
          bg={useColorModeValue('white', 'gray.800')}
          boxShadow={'2xl'}
          rounded={'lg'}
          pos={'relative'}
          zIndex={1}>
          <Box
            rounded={'lg'}
            mt={-12}
            pos={'relative'}
            height={'230px'}
            _after={{
              transition: 'all .3s ease',
              content: '""',
              w: 'full',
              h: 'full',
              pos: 'absolute',
              top: 5,
              left: 0,
              //backgroundImage: `url(${IMAGE})`,
              filter: 'blur(15px)',
              zIndex: -1,
            }}
            _groupHover={{
              _after: {
                filter: 'blur(20px)',
              },
            }}>
              <Heading fontSize={'2xl'} fontFamily={'body'} fontWeight={500}>
              <Link as={Reactlink}  to={props.path}> {props.description}
{             <Image
              rounded={'lg'}
              height={230}
              width={282}
             // objectFit={'cover'}
              src={props.imageSource}
            /> }
            </Link> 
            </Heading>
          </Box>
          <Stack pt={10} align={'center'}>
          </Stack>
        </Box>
       
      </Center>
    );
  }